import React from 'react';
import { Disc3 } from 'lucide-react';

interface HeaderProps {
  sampleRate: string;
  bitDepth: string;
}

export const Header: React.FC<HeaderProps> = ({
  sampleRate,
  bitDepth,
}) => {
  const shortRate = sampleRate.replace('.0 kHz', 'kHz').replace(' kHz', 'kHz');
  const shortBit = bitDepth.replace('-bit', 'B');

  return (
    <header className="glass-header stagger-item stagger-1">
      <div className="glass-brand-row">
        <div className="glass-logo-badge">
          <Disc3 size={15} className="glass-logo-icon spinning" />
          <span className="glass-brand-name">
            MUSIC<span className="glass-brand-dot">.</span>TV
          </span>
        </div>
        <span className="glass-lossless-pill">STUDIO FLAC</span>
      </div>

      <div className="glass-telemetry-pill">
        <span className="glass-dac-pulse" />
        <span className="glass-dac-spec">{shortBit} / {shortRate}</span>
      </div>
    </header>
  );
};
